"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalUtilityTokens = exports.UtilityClass = void 0;
var colors_1 = require("./colors");
var utils_1 = require("./utils");
var generateCSSClassNames = function (utilityVariables) {
    if (utilityVariables === void 0) { utilityVariables = {}; }
    var utilityNamesCSS = {};
    for (var key in utilityVariables) {
        var keyAsShortHandName = key;
        var newDotNotationKey = "." + keyAsShortHandName;
        utilityNamesCSS[newDotNotationKey] = utilityVariables[keyAsShortHandName];
    }
    return utilityNamesCSS;
};
// list of commonly used classes adding a few classes initially. Will scale up as needed.
exports.UtilityClass = {
    'w0': { width: '0' },
    'w10': { width: '10%' },
    'w20': { width: '20%' },
    'w25': { width: '25%' },
    'w30': { width: '30%' },
    'w40': { width: '40%' },
    'w50': { width: '50%' },
    'w60': { width: '60%' },
    'w70': { width: '70%' },
    'w80': { width: '80%' },
    'w90': { width: '90%' },
    'w75': { width: '75%' },
    'w100': { width: '100%' },
    'h0': { height: '0' },
    'h100': { height: '100%' },
    'bgPrimary': { backgroundColor: colors_1.SixsenseColor.Blue.DEFAULT },
    'bgWhite': { backgroundColor: colors_1.SixsenseColor.White.DEFAULT },
    'bgGray': { backgroundColor: colors_1.SixsenseColor.Gray.DEFAULT },
    'bgBlack': { backgroundColor: colors_1.SixsenseColor.Black.DEFAULT },
    'bgAccent': { backgroundColor: colors_1.SixsenseColor.Teal.DEFAULT },
    'textWhite': { color: colors_1.SixsenseColor.White.DEFAULT },
    'textBlack': { color: colors_1.SixsenseColor.Black.DEFAULT },
    'textGray': { color: colors_1.SixsenseColor.Gray.DEFAULT },
    'textPrimary': { color: colors_1.SixsenseColor.Blue.DEFAULT },
    'textAccent': { color: colors_1.SixsenseColor.Teal.DEFAULT },
    'dNone': { display: 'none' },
    'dFlex': { display: 'flex' },
    'alignItemsStart': { alignItems: 'flex-start' },
    'alignItemsCenter': { alignItems: 'center' },
    'alignItemsEnd': { alignItems: 'flex-end' },
    'justifyContentStart': { justifyContent: 'flex-start' },
    'justifyContentCenter': { justifyContent: 'center' },
    'justifyContentEnd': { justifyContent: 'flex-end' },
    'justifyContentSpaceBetween': { justifyContent: 'space-between' },
    'justifyContentSpaceAround': { justifyContent: 'space-around' },
    'justifyContentSpaceEvenly': { justifyContent: 'space-evenly' },
    'dFlexCenter': { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    'flexColumn': { display: 'flex', flexDirection: 'column' },
    'flexRow': { display: 'flex', flexDirection: 'row' },
    'shadowXS': { boxShadow: '0px 1px 2px #E5E7EB' },
    'shadowSM': { boxShadow: '0px 1px 3px #E5E7EB, 0px 1px 2px #E5E7EB' },
    'shadowMD': { boxShadow: '0px 4px 8px -2px #E5E7EB, 0px 2px 4px -2px #E5E7EB' },
    'shadowLG': { boxShadow: '0px 12px 16px -4px #E5E7EB, 0px 4px 6px -2px #E5E7EB' },
    'shadowXL': { boxShadow: '0px 20px 24px -4px #E5E7EB, 0px 8px 8px -4px #E5E7EB' },
    'shadowXXL': { boxShadow: '0px 24px 48px -12px #D2D6DB' },
    'shadowXXXL': { boxShadow: '0px 32px 64px -12px #D2D6DB' },
    'op0': { opacity: '0' },
    'op25': { opacity: '0.25' },
    'op50': { opacity: '0.5' },
    'op75': { opacity: '0.75' },
    'op100': { opacity: '1' },
    'borderRadius0': { borderRadius: utils_1.pxToRem(0 * utils_1.SIZE_CONSTANT) },
    'borderRadius1': { borderRadius: utils_1.pxToRem(0.25 * utils_1.SIZE_CONSTANT) },
    'borderRadius2': { borderRadius: utils_1.pxToRem(0.5 * utils_1.SIZE_CONSTANT) },
    'borderRadius3': { borderRadius: utils_1.pxToRem(0.7 * utils_1.SIZE_CONSTANT) },
    'borderRadius4': { borderRadius: utils_1.pxToRem(1 * utils_1.SIZE_CONSTANT) },
    'borderRadius5': { borderRadius: utils_1.pxToRem(1.5 * utils_1.SIZE_CONSTANT) },
    'noBorder': { border: 'none' },
    'borderGray1': { border: "1px solid " + colors_1.SixsenseColor.Gray.DARK_1 },
    'borderGray2': { border: "1px solid " + colors_1.SixsenseColor.Gray.DEFAULT },
    'borderGray3': { border: "1px solid " + colors_1.SixsenseColor.Gray.LIGHT_1 },
    'borderGray4': { border: "1px solid " + colors_1.SixsenseColor.Gray.LIGHT_2 },
    'borderGray5': { border: "1px solid " + colors_1.SixsenseColor.Gray.LIGHT_3 },
    'borderGray': { border: "1px solid " + colors_1.SixsenseColor.Gray.LIGHT_4 },
    'textUpperCase': { textTransform: 'uppercase' },
    'textLowerCase': { textTransform: 'lowercase' },
    'textCapitalize': { textTransform: 'capitalize' },
    'textUnderline': { textDecoration: 'underline' },
    'fontWeightRegular': { fontWeight: 100 },
    'fontWeightMedium': { fontWeight: 300 },
    'fontWeightSemiBold': { fontWeight: 500 },
    'fontWeightBold': { fontWeight: 700 },
    'fontSize1': { fontSize: 0.75 + (0 * 0.125) + "rem" },
    'fontSize2': { fontSize: 0.75 + (1 * 0.125) + "rem" },
    'fontSize3': { fontSize: 0.75 + (2 * 0.125) + "rem" },
    'fontSize4': { fontSize: 0.75 + (3 * 0.125) + "rem" },
    'fontSize5': { fontSize: 0.75 + (4 * 0.125) + "rem" },
    'fontSize6': { fontSize: 0.75 + (5 * 0.125) + "rem" },
    'fontSize7': { fontSize: 0.75 + (6 * 0.125) + "rem" },
    'fontSize8': { fontSize: 0.75 + (7 * 0.125) + "rem" },
    'fontSize9': { fontSize: 0.75 + (8 * 0.125) + "rem" },
    'fontSize10': { fontSize: 0.75 + (9 * 0.125) + "rem" },
    'fontSize11': { fontSize: 0.75 + (10 * 0.125) + "rem" },
    'fontSize12': { fontSize: 0.75 + (11 * 0.125) + "rem" },
    'fontSize13': { fontSize: 0.75 + (12 * 0.125) + "rem" },
    'fontSize14': { fontSize: 0.75 + (13 * 0.125) + "rem" },
    'fontSize15': { fontSize: 0.75 + (14 * 0.125) + "rem" },
};
/**
 * Global utility classes to be used by devs for commonly used styling rules
 *
 * Example:
 * <div className="w100"></div>
 * -- style applied to the above div is
 * -- width: 100%
 */
exports.GlobalUtilityTokens = {
    cssUtilityObj: generateCSSClassNames(exports.UtilityClass),
    emotionUtilityObj: exports.UtilityClass,
};
